import { createApiBuilder } from 'haper';
import { appFetch } from '../shared/fetch';
import { haper } from '../shared/haper';
import { Compound, Substance } from '../shared/models/Substance';

const api = createApiBuilder(haper);

export type SearchBy = 'name' | 'cas';

export interface FetchedDataParams {
    offset?: number;
    size?: number;
    search?: string;
    searchBy?: SearchBy;
}

export interface ReportSubstanceParams {
    email: string;
    substance: string;
    process: string;
    message: string;
    recaptcha_response: string;
    rodo: boolean;
}

export const getDataLists = api.get<
    {
        total: number;
        data: Array<Substance | Compound>;
    },
    FetchedDataParams
>('/substances');

// export const reportSubstance = api.post<{}, ReportSubstanceParams>(
//     '/report-substance',
// );
export const reportSubstance = async (data: ReportSubstanceParams) =>
    await appFetch(window.appConfig.POST_URL || window.location.href, data, {
        method: 'POST',
    });
